import { render } from "./chat_list_item.vue?vue&type=template&id=480904b4"
import script from "./chat_list_item.js?vue&type=script&lang=js"
export * from "./chat_list_item.js?vue&type=script&lang=js"

import "./chat_list_item.vue?vue&type=style&index=0&id=480904b4&lang=scss"

import exportComponent from "/home/jojo/Documents/aspho-fe-pleromer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__